import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder } from '@/src/elements/placeholder'
import { Spacer } from '@/src/elements/spacer/Spacer'
import { Typography } from '@/src/elements/text/Typography'
import { useTranslate } from '@/src/lang/useTranslate'

import type { INTENTION_TYPE } from '../../../models/Intention.enums'
import type { TTypeIntention } from '../../../models/Intention.types'

const BIRTHDAY_EMOJI = '🎂'

type TBirthdayContentProps = {
  intention?: TTypeIntention<INTENTION_TYPE.BIRTHDAY>
}

export const BirthdayContent = ({ intention }: TBirthdayContentProps): ReactNode => {
  const { t } = useTranslate()

  if (!intention) return <Placeholder className="h-4 w-40" />

  const age = intention.user.birthdate
    ? new Date(Date.now()).getFullYear() - new Date(intention.user.birthdate).getFullYear()
    : undefined

  return (
    <>
      <View className="items-center py-4">
        <Typography size="3xl" className="pr-3" role="img" aria-label={t('user.happy-birthday.wish')}>
          {BIRTHDAY_EMOJI}
        </Typography>
        <Typography bold colors="primary" className="max-w-72">
          {t('intention.birthday.years-old', { age })}
        </Typography>
      </View>
      <Spacer y={6} />
    </>
  )
}
